import React, { useRef, useLayoutEffect } from 'react';
import { cn } from '../../utils/classNames';

const labelClasses = 'block mb-2 text-content font-sans';

const textareaClasses = `
  block w-full h-40 px-3 py-1.5
  font-sans text-base text-content
  bg-white border border-border rounded-md
  resize-none transition-colors
  focus:outline-none focus:ring-2 focus:ring-primary-ring
  disabled:opacity-60 disabled:cursor-not-allowed
`;

const errorClasses = 'block mt-1 ml-1 text-sm text-danger';

const XTextarea = ({ label, name, value, onChange, placeholder, disabled = false, className, autoResize = false, error, ...props }) => {
    const textareaRef = useRef(null);

     
    useLayoutEffect(() => {
        if (!autoResize) return;
        const el = textareaRef.current;
        if (!el) return;
        el.style.height = 'auto';
        el.style.height = `${el.scrollHeight}px`;
    }, [autoResize, value]);

    return (
        <React.Fragment>
            {label && <label className={labelClasses}>{label}</label>}
            <textarea
                ref={textareaRef}
                name={name}
                value={value || ''}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                className={cn(textareaClasses, autoResize && 'resize-none overflow-hidden', className)}
                {...props}
            />
            {error && <span className={errorClasses}>{error}</span>}
        </React.Fragment>
    );
};

export default XTextarea;
